import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { LoadingButton } from "@mui/lab";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid2";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";

import { NumericFormat } from "react-number-format";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import { Button, Divider, InputAdornment } from "@mui/material";
import FileDownload from "@mui/icons-material/FileDownload";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import InputRut from "../GeneralComponents/InputRut";
import ModalStandard from "../GeneralComponents/ModalStandard";
import HourglassLoader from "../GeneralComponents/HourglassLoader";
import FasHiddenPreview from "./FasHiddenPreview";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";
import { toSnakeCase } from "../utils/general_utils";

const DEFAULT_FORM_DATA = {
  rut: "",
  operator_name: "",
  id_operador: "",
  rbd: "",
  ees_name: "",
  ees_managers: [""],
  ees_managers_email: [""],
  ees_temporal_manager_list: [""],
  ees_temporal_manager: "",
  ees_temporal_manager_email: "",
  ees_temporal_manager_nombres: "",
  ees_temporal_manager_apellidos: "",
  tech_id: "",
  int_speed_down: 0,
  installation_date: dayjs(),
  speed_up: 0,
  speed_down: 0,
  latency: 0,
  packet_loss: 0,
  checked: false,
  images: [],
  evidence: [],
  validation_data: {},
};

export default function FasOverwrite() {
  const { setPageTitle, setDrawerHidding } = useContext(GeneralContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const fasRef = useRef(null);
  const rutRef = useRef(null);
  const evidenceRef = useRef(null);

  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);
  const [techTypes, setTechTypes] = useState([]);
  const [countArray, setCountArray] = useState(1);
  const [pdfUrl, setPdfUrl] = useState("");

  const [loading, setLoading] = useState(true);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [submitConfirm, setSubmitConfirm] = useState(false);

  const [evError, setEvError] = useState(true);
  const [errorRut, setErrorRut] = useState(false);

  const [open, setOpen] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const links = [
    { name: "Inicio", path: "/home" },
    { name: "Listado FAS", path: "/fas_lista" },
    { name: "Recrear FAS", path: `/fas_overwrite/${id}` },
  ];

  const getFileNameFromUrl = (url) => {
  if (!url) return "evidencia";
  try {
    const decoded = decodeURIComponent(String(url).split("?")[0]);
    const fileName = decoded.split("/").pop() || "evidencia";

    // eliminar prefijo de fecha tipo 2026_02_13-06_25_52_PM_
    return fileName.replace(/^\d{4}_\d{2}_\d{2}-\d{2}_\d{2}_\d{2}_(AM|PM)_/, "");
  } catch (_) {
    const fileName = String(url).split("/").pop() || "evidencia";
    return fileName.replace(/^\d{4}_\d{2}_\d{2}-\d{2}_\d{2}_\d{2}_(AM|PM)_/, "");
  }
};
  const createFakeEvidence = (urlOrName) => {
    const fileName = getFileNameFromUrl(urlOrName);
    const lowerName = fileName.toLowerCase();
    const mimeType = lowerName.endsWith(".pdf") ? "application/pdf" : "image/jpeg";
    const fakeBlob = new Blob([""], { type: mimeType });
    const file = new File([fakeBlob], fileName, { type: mimeType });
    file.isExistingEvidence = true;
    file.sourceUrl = urlOrName;
    return file;
  };

  const normalizeEvidenceUrls = (payload, datos) => {
    const urls =
      datos?.evidence ||
      datos?.images ||
      datos?.imagenes_url ||
      datos?.images_url ||
      datos?.evidencias_url ||
      datos?.evidence_url ||
      datos?.rutas_evidencia ||
      payload?.evidence ||
      payload?.imagenes_url ||
      payload?.images_url ||
      payload?.evidencias_url ||
      payload?.evidence_url ||
      payload?.rutas_evidencia ||
      [];

    if (Array.isArray(urls)) return urls.filter(Boolean);
    if (typeof urls === "string" && urls.trim() !== "") return [urls];
    return [];
  };

  const getOperatorByRut = (rut) => {
    axios
      .getOperator(rut)
      .then((response) => {
        setFormData((prev) => ({
          ...prev,
          operator_name: response.data.operador || prev.operator_name,
          id_operador: response.data.id_operador || prev.id_operador,
        }));
      })
      .catch((error) => {
        console.error("Error en getOperatorByRut:", error);
      });
  };

  const getTechType = () => {
    axios
      .getTechTypes()
      .then((response) => setTechTypes(response.data || []))
      .catch((error) => console.error("Error en getTechTypes:", error));
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.getFas(id);
      const payload = response.data || {};
      const datos = payload?.datos || payload?.data || payload || {};
      const evidenceUrls = normalizeEvidenceUrls(payload, datos);
      const loadedImages = evidenceUrls.map((url) => createFakeEvidence(url));

      const rutOperador = datos.rut || "";
      const rbdFas = datos.rbd || payload.rbd || "";
      const managers = datos.ees_managers || datos.nombres_representantes || [""];
      const managerEmails = datos.ees_managers_email || datos.email_representantes || [""];

      setFormData((prev) => ({
        ...prev,
        ...datos,
        rut: rutOperador,
        operator_name: datos.operator_name || datos.operador || prev.operator_name,
        id_operador: datos.id_operador || payload.id_operador || prev.id_operador,
        rbd: rbdFas,
        ees_name: datos.ees_name || datos.nombre_colegio || "",
        ees_managers: managers,
        ees_managers_email: managerEmails,
        ees_temporal_manager_list: datos.ees_temporal_manager_list || ["Sin representante"],
        tech_id: datos.tech_id || datos.id_tipo_tecnologia || payload.id_tipo_tecnologia || "",
        installation_date: dayjs(datos.installation_date || datos.fecha_instalacion || new Date()),
        checked: !!datos.checked,
        images: loadedImages,
        evidence: evidenceUrls,
        validation_data: datos.validation_data || {},
      }));

      setPdfUrl(payload?.ruta_url || payload?.pdf_url || payload?.file_url || "");
      setEvError(loadedImages.length === 0);
      setCountArray(Math.max(managers.length || 0, managerEmails.length || 0, 1));

      if (rutOperador) getOperatorByRut(rutOperador);
    } catch (error) {
      console.error("Error al obtener FAS:", error);
      setModalError(true);
      setModalContent("No fue posible cargar el documento FAS");
      setOpen(true);
    } finally {
      setLoading(false);
      setPageLoaded(true);
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    const uniqueFiles = files.filter(
      (file) => !formData.images.some((img) => img.name === file.name)
    );

    const updatedImages = [...formData.images, ...uniqueFiles];
    setFormData((prev) => ({ ...prev, images: updatedImages }));
    setEvError(updatedImages.length === 0);
    event.target.value = null;
  };

  const handleRemoveImage = (imageName) => {
    const updatedImages = formData.images.filter((image) => image.name !== imageName);
    setFormData((prev) => ({ ...prev, images: updatedImages }));
    setEvError(updatedImages.length === 0);
  };

  const handleSwitch = (event) => {
    setFormData((prev) => ({ ...prev, checked: event.target.checked }));
  };

  const handleDropDown = (value) => {
    setFormData((prev) => ({ ...prev, tech_id: value }));
  };

  const handleDownloadPdf = () => {
    setLoadingPdf(true);

    setTimeout(() => {
      const element = fasRef.current;

      html2canvas(element, { scale: 2 })
        .then((canvas) => {
          const imageData = canvas.toDataURL("image/jpeg", 1);
          const pdfWidth = 210;
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
          const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight + 7]);

          pdf.setFillColor(255, 255, 255);
          pdf.rect(0, 0, pdfWidth, pdfHeight + 140, "F");
          pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight);

          const pdfBlob = pdf.output("blob");
          const existingEvidence = formData.images
            .filter((image) => image.isExistingEvidence && image.sourceUrl)
            .map((image) => image.sourceUrl);

          const localFormData = {
            ...formData,
            rut: formData.rut || "",
            rbd: formData.rbd || "",
            installation_date: formData.installation_date
              ? dayjs(formData.installation_date).locale("es").format("YYYY/MM/DD HH:mm:ss").toString()
              : null,
            existing_evidence: existingEvidence,
          };

          const form = new FormData();
          form.append("data", JSON.stringify(localFormData));

          localFormData.images.forEach((image) => {
            if (!image.isExistingEvidence) form.append("evidence", image);
          });

          form.append("file", pdfBlob, "temp.pdf");

          axios
            .overwriteFilesFas(form, id)
            .then(() => {
              setLoading(false);
              setSubmitConfirm(false);
              setModalError(false);
              setModalContent("Documento FAS modificado");
              setOpen(true);
            })
            .catch((error) => {
              console.error("Error en overwriteFilesFas:", error);
              setModalError(true);
              setModalContent("La modificación del documento FAS ha fallado");
              setLoading(false);
            })
            .finally(() => {
              setLoadingPdf(false);
              setLoadingButton(false);
            });
        })
        .catch((error) => {
          console.error("Error generando el PDF:", error);
          setLoadingPdf(false);
          setLoading(false);
          setLoadingButton(false);
          setSubmitConfirm(false);
        });
    }, 0);
  };

  const handleClick = (event) => {
    event.preventDefault();
    if (loadingButton) return;
    setLoadingButton(true);

    if (!submitConfirm) {
      setSubmitConfirm(true);
      setLoadingButton(false);
      return;
    }

    if (formData.images.length === 0) {
      setEvError(true);
      evidenceRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      setLoadingButton(false);
      return;
    }

    if (errorRut && formData.checked) {
      rutRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      setLoadingButton(false);
      return;
    }

    setLoading(true);
    handleDownloadPdf();
  };

  useEffect(() => {
    setPageTitle("Recrear Formulario electrónico de Alta del Servicio (FAS)");
    setDrawerHidding(false);
    getTechType();
    fetchData();
  }, []);

  if (!pageLoaded) return <Box />;

  return (
    <>
      <PageBody>
        <BreadcrumbStandard links={links} />

        <PageBgBlock>
          <Grid container spacing={2}>
            <Grid size={8}>
              <TextField
                disabled
                size="small"
                variant="outlined"
                placeholder="Documento actual"
                value={pdfUrl}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" sx={{ marginLeft: "10px" }}>
                      <ImageSearchIcon sx={{ color: "black" }} />
                    </InputAdornment>
                  ),
                  readOnly: true,
                }}
                sx={{ width: "100%", maxWidth: "100%" }}
              />
            </Grid>
            <Grid size={4}>
              <Button
                fullWidth
                variant="text"
                disabled={!pdfUrl}
                color="primary"
                onClick={() => window.open(pdfUrl, "_blank")}
                startIcon={<FileDownload />}
              >
                Ver documento actual
              </Button>
            </Grid>
          </Grid>
        </PageBgBlock>

        <Box sx={{ margin: 5 }} />

        {loading ? (
          <HourglassLoader />
        ) : (
          <Stack sx={{ background: "#FFFFFF", borderRadius: "0.5rem" }}>
            <Box sx={{ paddingLeft: "9rem", paddingRight: "9rem", paddingTop: "2rem" }}>
              <Stack alignItems="left" justifyContent="center" spacing={2}>
                <Typography
                  variant="h1"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
                >
                  RECREAR FORMULARIO FAS
                </Typography>

                <Box justifyContent="center" sx={{ display: "flex" }}>
                  <Typography variant="small" color="inherit" sx={{ textAlign: "center", paddingX: "8rem" }}>
                    N° folio:
                    <Typography variant="small" sx={{ color: "#FFF", paddingLeft: "1rem" }}>
                      00000000
                    </Typography>
                  </Typography>
                </Box>

                <Box justifyContent="center" sx={{ maxWidth: "100%", margin: "0 auto", display: "flex" }}>
                  <Typography variant="body" align="center" sx={{ marginBottom: "2rem" }}>
                    Le presentamos el Formulario de Alta de Servicio, por favor llene todos los campos indicados para un proceso exitoso entre todos los involucrados (operador, EES, SUBTEL y MINEDUC)
                  </Typography>
                </Box>

                <Typography component="h1" variant="h3" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                  DATOS DEL OPERADOR
                </Typography>

                <form onSubmit={handleClick} id="fas">
                  <FormControl sx={{ m: 1, width: "100%", spacing: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={6}>
                        <TextField
                          test_id={toSnakeCase("rut")}
                          disabled
                          label="RUT Operador Instalador"
                          size="small"
                          sx={{ width: "100%" }}
                          value={formData.rut || ""}
                        />
                      </Grid>
                      <Grid size={6}>
                        <TextField
                          test_id={toSnakeCase("operator_name")}
                          disabled
                          label="Operador"
                          size="small"
                          sx={{ width: "100%" }}
                          value={formData.operator_name || ""}
                        />
                      </Grid>
                    </Grid>
                  </FormControl>

                  <Typography variant="h3" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                    DATOS DEL EES
                  </Typography>

                  <FormControl sx={{ m: 1, minWidth: "100%" }}>
                    <TextField
                      required
                      disabled
                      test_id={toSnakeCase("rbd")}
                      label="RBD"
                      size="small"
                      sx={{ width: "100%" }}
                      value={formData.rbd || ""}
                    />
                  </FormControl>

                  <FormControl sx={{ m: 1, width: "100%", spacing: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={12}>
                        <TextField
                          test_id={toSnakeCase("ees_name")}
                          label="Nombre del Colegio"
                          size="small"
                          disabled
                          value={formData.ees_name || ""}
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      {Array.from({ length: countArray }).map((_, i) => (
                        <React.Fragment key={i}>
                          <Grid size={6}>
                            <TextField
                              test_id={toSnakeCase(`ees_managers_${i}`)}
                              label={`Representante del establecimiento ${i + 1}`}
                              size="small"
                              disabled
                              value={formData?.ees_managers?.[i] ?? ""}
                              sx={{ width: "100%" }}
                            />
                          </Grid>

                          <Grid size={6}>
                            <TextField
                              test_id={toSnakeCase(`ees_managers_email_${i}`)}
                              label={`Email Representante del establecimiento ${i + 1}`}
                              size="small"
                              disabled
                              value={formData?.ees_managers_email?.[i] ?? ""}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                  </FormControl>

                  <Box ref={rutRef}>
                    <InputRut
                      error={errorRut}
                      errorRut={setErrorRut}
                      checked={formData.checked}
                      email={formData.ees_temporal_manager_email}
                      rut={formData.ees_temporal_manager}
                      nombre_temp={formData.ees_temporal_manager_nombres}
                      apellido_temp={formData.ees_temporal_manager_apellidos}
                      handleSwitch={handleSwitch}
                      handleRut={(newValue) => setFormData((prev) => ({ ...prev, ees_temporal_manager: newValue }))}
                      handleEmail={(newValue) => setFormData((prev) => ({ ...prev, ees_temporal_manager_email: newValue }))}
                      handleNombre={(newValue) => setFormData((prev) => ({ ...prev, ees_temporal_manager_nombres: newValue }))}
                      handleApellido={(newValue) => setFormData((prev) => ({ ...prev, ees_temporal_manager_apellidos: newValue }))}
                    />
                  </Box>

                  <Typography variant="h3" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                    DATOS DE CONEXIÓN
                  </Typography>

                  <FormControl sx={{ m: 1, width: "100%", spacing: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={12}>
                        <InputLabel size="small" id="tech_id">
                          Tecnología
                        </InputLabel>
                        <Select
                          test_id={toSnakeCase("tech_id")}
                          required
                          value={formData.tech_id || ""}
                          labelId="tech_id"
                          label="Tecnología"
                          size="small"
                          sx={{ width: "100%" }}
                          onChange={(event) => handleDropDown(event.target.value)}
                        >
                          {techTypes.map((tech, index) => (
                            <MenuItem
                              test_id={toSnakeCase(`menu_tech_id_${index}`)}
                              key={tech.id_tipo_tecnologia || index}
                              value={tech.id_tipo_tecnologia}
                            >
                              {tech.nombre_enlace}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      <Grid size={6}>
                        <NumericFormat
                          test_id={toSnakeCase("speed_up")}
                          required
                          customInput={TextField}
                          label="Vel. subida total Nacional (Mbps)"
                          value={formData.speed_up}
                          onValueChange={(newValue) => setFormData((prev) => ({ ...prev, speed_up: newValue.value }))}
                          allowNegative={false}
                          size="small"
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid size={6}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es"
                          localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
                        >
                          <DateTimePicker
                            test_id={toSnakeCase("installation_date")}
                            label="Fecha instalación"
                            slotProps={{ textField: { size: "small" } }}
                            value={formData.installation_date}
                            sx={{ width: "100%" }}
                            onChange={(newValue) => setFormData((prev) => ({ ...prev, installation_date: newValue }))}
                            disableFuture
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </FormControl>

                  <FormControl sx={{ m: 1, width: "100%", spacing: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={6}>
                        <NumericFormat
                          test_id={toSnakeCase("speed_down")}
                          required
                          customInput={TextField}
                          label="Vel. bajada total Nacional (Mbps)"
                          value={formData.speed_down}
                          onValueChange={(newValue) => setFormData((prev) => ({ ...prev, speed_down: newValue.value }))}
                          allowNegative={false}
                          size="small"
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid size={6}>
                        <NumericFormat
                          test_id={toSnakeCase("int_speed_down")}
                          required
                          customInput={TextField}
                          label="Vel. bajada total Internacional (Mbps)"
                          value={formData.int_speed_down}
                          onValueChange={(newValue) => setFormData((prev) => ({ ...prev, int_speed_down: newValue.value }))}
                          allowNegative={false}
                          size="small"
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    </Grid>
                  </FormControl>

                  <FormControl sx={{ m: 1, width: "100%", spacing: 2 }}>
                    <Grid container spacing={2}>
                      <Grid size={6}>
                        <NumericFormat
                          test_id={toSnakeCase("latency")}
                          required
                          customInput={TextField}
                          label="Latencia (ms)"
                          value={formData.latency}
                          onValueChange={(newValue) => setFormData((prev) => ({ ...prev, latency: newValue.value }))}
                          allowNegative={false}
                          size="small"
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid size={6}>
                        <NumericFormat
                          test_id={toSnakeCase("packet_loss")}
                          required
                          customInput={TextField}
                          label="Pérdida de paquetes (%)"
                          value={formData.packet_loss}
                          onValueChange={(newValue) => setFormData((prev) => ({ ...prev, packet_loss: newValue.value }))}
                          size="small"
                          sx={{ width: "100%" }}
                          isAllowed={(values) => {
                            if (values.value === "") return true;
                            return values.floatValue < 100;
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormControl>

                  <FormControl sx={{ m: 1, minWidth: "100%" }}>
                    <Paper elevation={1} sx={{ width: "100%", borderRadius: "0.5rem" }}>
                      <Grid container spacing={2}>
                        <Grid display="flex" justifyContent="flex-start" size={12} sx={{ maxHeight: "small" }}>
                          <Typography variant="body" sx={{ padding: "0.5rem" }}>
                            <Grid container spacing={2}>
                              <Grid display="flex" justifyContent="flex-start" size={12} sx={{ maxHeight: "small" }}>
                                <CollectionsOutlinedIcon sx={{ marginRight: "0.5rem" }} />
                                Subir evidencias.
                              </Grid>
                            </Grid>
                          </Typography>
                          <Box sx={{ flexGrow: 1 }} />
                          <Divider orientation="vertical" flexItem />
                          <LoadingButton
                            test_id={toSnakeCase("Subir evidencias")}
                            component="label"
                            role={undefined}
                            variant="text"
                            tabIndex={-1}
                            startIcon={<FileUploadOutlinedIcon />}
                            sx={{ textDecoration: "underline", marginLeft: "1%" }}
                          >
                            Subir evidencias
                            <input
                              type="file"
                              accept="image/*,application/pdf"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                              multiple
                            />
                          </LoadingButton>
                        </Grid>
                      </Grid>

                      <Divider orientation="horizontal" flexItem />

                      <Grid container spacing={0} ref={evidenceRef}>
                        <Grid display="flex" justifyContent="flex-start" alignItems="center" size={12}>
                          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
                            <ListItem sx={{ justifyContent: "flex-start" }}>
                              <Typography align="center" sx={{ color: evError ? "red" : "#111" }}>
                                {evError ? "Debe adjuntar evidencia de la instalación" : "Lista de evidencias a subir"}
                              </Typography>
                            </ListItem>

                            {formData.images.map((image, index) => (
                              <ListItem divider key={`${image.name}-${index}`} display="flex" alignItems="flex-start">
                                <ListItemAvatar>
                                  {image.type?.startsWith("image/") ? (
                                    <Avatar variant="rounded" alt="preview" src={image.isExistingEvidence ? image.sourceUrl : URL.createObjectURL(image)} />
                                  ) : (
                                    <Avatar variant="rounded" alt="pdf">
                                      <PictureAsPdfOutlinedIcon />
                                    </Avatar>
                                  )}
                                </ListItemAvatar>
                                <ListItemText
                                  primaryTypographyProps={{ style: { color: "black" } }}
                                  primary={image.name}
                                  secondary={image.isExistingEvidence ? "Evidencia actual" : "Nueva evidencia"}
                                />
                                {image.sourceUrl && (
                                  <LoadingButton size="small" variant="text" onClick={() => window.open(image.sourceUrl, "_blank")}>
                                    Ver
                                  </LoadingButton>
                                )}
                                <LoadingButton
                                  test_id={toSnakeCase(`eliminar_${index}`)}
                                  size="small"
                                  variant="text"
                                  color="error"
                                  onClick={() => handleRemoveImage(image.name)}
                                >
                                  Eliminar
                                </LoadingButton>
                              </ListItem>
                            ))}
                          </List>
                        </Grid>

                        <Grid size={12}>
                          <Typography variant="small" align="left" sx={{ px: 2, pb: 2, display: "block" }}>
                            *Atención: Se recomienda que las fotografías dentro de la evidencia vengan georeferenciadas (marca de fecha y lugar en la que se tomó) esto será validado por SUBTEL y no por la plataforma SAGEC.
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  </FormControl>
                </form>
              </Stack>
            </Box>

            <Stack sx={{ paddingLeft: "9rem", paddingRight: "9rem", paddingBottom: "2rem" }}>
              <FormControl sx={{ m: 1, maxWidth: "100%" }}>
                <Grid container spacing={2}>
                  {submitConfirm ? (
                    <Grid display="flex" justifyContent="center" alignItems="center" size={12}>
                      <Alert
                        icon={false}
                        variant="filled"
                        severity="warning"
                        sx={{ display: "flex", justifyContent: "center", "& .MuiAlert-message": { textAlign: "center", width: "inherit" } }}
                      >
                        <Typography variant="body" color="inherit" sx={{ textAlign: "center" }}>
                          Revise que todos los campos tienen la información correcta antes de enviar el formulario FAS, al clickear “Recrear FAS” el documento queda firmado por el operador.
                        </Typography>
                      </Alert>
                    </Grid>
                  ) : null}

                  <Grid display="flex" justifyContent="center" alignItems="center" size={12}>
                    <Stack sx={{ paddingLeft: "9rem", paddingRight: "9rem", paddingBottom: "3rem" }}>
                      <PageButtonBlack form="fas" disabled={evError} loading={loadingButton}>
                        Recrear FAS
                      </PageButtonBlack>
                    </Stack>
                  </Grid>
                </Grid>
              </FormControl>
            </Stack>
          </Stack>
        )}
      </PageBody>

      {loadingPdf ? (
        <Box sx={{ maxWidth: "100%", overflow: "hidden", position: "absolute", width: "1200px", height: "0" }}>
          <Box ref={fasRef} sx={{ padding: "12px" }}>
            <FasHiddenPreview formData={formData} techTypes={techTypes} />
          </Box>
        </Box>
      ) : null}

      <ModalStandard
        open={open}
        error={modalError}
        title={modalContent}
        btnText="Ir al listado"
        onClick={() => navigate("/fas_lista")}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
